import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";

import { IEditBrandUser } from "@shared/lib/types";
import {
  BRAND_ME_SEARCH_QUERY_KEY,
  ORGANISATION_LIST_QUERY_KEY,
} from "../constants";
import { OrganisationService } from "../services/organisation.service";

const QUERY_OPTIONS = {
  queryKey: ORGANISATION_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useEditOrganisationUser(
  brandOrganisationId: string,

  handleCallBack?: () => void
) {
  const assignUserBrand = useCallback(
    ({
      brandUserId,
      brandUser,
      // brandOrganisationId,
    }: {
      brandUserId: string;
      brandUser: Partial<IEditBrandUser>;
      // brandOrganisationId: string;
    }) =>
      OrganisationService.updateOrganisationUser(
        brandUserId,
        brandUser
        // brandOrganisationId,
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: updateOrganisationUser,
    isLoading: isUpdatingOrganisationUser,
    isSuccess: isUpdatedOrganisationUser,
    error: updateOrganisationUserError,
    variables,
  } = useMutation({
    mutationFn: assignUserBrand,
    options: QUERY_OPTIONS,
    onSuccess: (c, _, {}) => {
      c.invalidateQueries({
        queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
      });
      c.invalidateQueries({
        queryKey: BRAND_ME_SEARCH_QUERY_KEY(brandOrganisationId),
      });
    },
  });

  return {
    updateOrganisationUser,
    isUpdatingOrganisationUser,
    isUpdatedOrganisationUser,
    updateOrganisationUserError,
    editOrganisationBrandUserId: variables?.brandUserId,
  };
}
